import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import CompanyList from "./CompanyList";
import { ModalPickerProps } from "../props";
import RemovableCompany from "components/Removables/RemovableCompany";
import { toCompanySmall } from "shared/utils/companyUtils";
import { LayoutType } from "components/SmallDetails";
import { useOpenNewCompanySidePanel } from "components/SidePanel/Company/NewCompanySidePanel";
import { AfterCreateAction } from "components/SidePanel/types";

type Props = Omit<ModalPickerProps<server.dto.CompanySmall>, "canCreateNew"> & {
  modalTitle: string;
  addressType: server.dto.AddressTypes;
  hideEditButton?: boolean;
  layout?: LayoutType;
} & (
    | { canCreateNew: false; afterCreate?: AfterCreateAction }
    | { canCreateNew: boolean; afterCreate: AfterCreateAction }
  );

const CompanyModalPicker = (props: Props) => {
  const { modalTitle, addressType, hideEditButton, layout, afterCreate, ...rest } = props;
  const openNewCompanySidePanel = useOpenNewCompanySidePanel();
  const onChange = (value: server.dto.CompanySmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };

  return <>
    <ModalPickerWithChooseButton
      onNewClicked={() => openNewCompanySidePanel({
        type: "company",
        onCreated: (c) => onChange(toCompanySmall(c)),
        afterCreate: afterCreate ?? "closeSidebar"
      })}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={modalTitle}
      modalSize="tiny"
      renderModalContent={(closeModal) => <CompanyList
        addressType={addressType}
        onItemSelected={(company) => {
          closeModal();
          onChange(company);
        }}
      />}
      renderRemovable={(innerProps) => <RemovableCompany {...innerProps} hideEditButton={hideEditButton} layout={layout ?? "singleLine"} />}
      {...rest}
    />
  </>;
};

export default CompanyModalPicker;